import { kallSjekkOmSesjonUtloper } from './api';
import type { InaktivitetsResponseType } from './types';

let grunnetInaktivitet = true;
const FallbackIntervalMilliSeconds = 5 * 60 * 1000; // 5 min

export function startSjekkForInaktivitet(bekreft: InaktivitetsResponseType['bekreft'] = false) {
  kallSjekkOmSesjonUtloper({ grunnetInaktivitet, bekreft })
    .then((res) => {
      if (res.skalViseModal) {
        import('./InaktivitetsModal').then(({ lagOgVisInaktivitetsModal }) => {
          lagOgVisInaktivitetsModal({ erInaktivitetsVariant: res.inaktivitet! });
          grunnetInaktivitet = res.inaktivitet!;
        });
      }
      if (!res.tidTilNesteSjekkSekunder) {
        // Dette skal så å si aldri skje, men er føre var her.
        throw new Error('Tid mangler');
      }
      setTimeout(() => startSjekkForInaktivitet(res.bekreft), res.tidTilNesteSjekkSekunder * 1000);
    })
    .catch(() => {
      setTimeout(() => startSjekkForInaktivitet(), FallbackIntervalMilliSeconds);
    });
}

export default startSjekkForInaktivitet;
